// stock-status-updater.js - Complete working version
(function() {
    'use strict';
    
    // Translation mappings
    const translations = {
        en: {
            'in_stock': 'In stock',
            'low_stock': 'Low stock',
            'out_of_stock': 'Out of stock',
            'ships_today': 'ships today',
            'few_items_left': 'Only a few items left!',
            'notify_me': 'Notify me'
        },
        nl: {
            'in_stock': 'Op voorraad',
            'low_stock': 'Bijna uitverkocht',
            'out_of_stock': 'Uitverkocht',
            'ships_today': 'vandaag verzonden',
            'few_items_left': 'Nog maar een paar items. Wees er snel bij!',
            'notify_me': 'Bericht mij'
        }
    };

    // Get current language
    function getCurrentLanguage() {
        return document.documentElement.lang?.split('-')[0] || 'en';
    }

    // Fix translation missing texts
    function fixTranslationMissing() {
        const lang = getCurrentLanguage();
        const trans = translations[lang] || translations.en;
        
        // Create a tree walker to find all text nodes
        const walker = document.createTreeWalker(
            document.body,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function(node) {
                    return node.nodeValue && node.nodeValue.includes('Translation missing:') 
                        ? NodeFilter.FILTER_ACCEPT 
                        : NodeFilter.FILTER_REJECT;
                }
            }
        );

        const textNodes = [];
        while (walker.nextNode()) {
            textNodes.push(walker.currentNode);
        }

        // Replace text in found nodes
        textNodes.forEach(node => {
            let text = node.nodeValue;
            
            // Replace all possible translation missing patterns
            Object.keys(trans).forEach(key => {
                const pattern = new RegExp(`Translation missing:\\s*[a-z_.-]*\\.${key}`, 'gi');
                text = text.replace(pattern, trans[key]);
            });
            
            // Also handle specific full paths
            text = text
                .replace(/Translation missing:\s*en\.products\.stock_status\.in_stock/gi, trans.in_stock)
                .replace(/Translation missing:\s*en\.products\.stock_status\.low_stock/gi, trans.low_stock)
                .replace(/Translation missing:\s*en\.products\.stock_status\.out_of_stock/gi, trans.out_of_stock)
                .replace(/Translation missing:\s*en\.products\.stock_status\.ships_today/gi, trans.ships_today)
                .replace(/Translation missing:\s*en\.products\.stock_status\.few_items_left/gi, trans.few_items_left)
                .replace(/Translation missing:\s*en\.products\.stock_status\.notify_me/gi, trans.notify_me);
            
            node.nodeValue = text;
        });
    }

    // Initialize notify buttons
    function initNotifyButtons() {
        document.querySelectorAll('.notify-me-link').forEach(button => {
            // Remove any existing onclick attributes
            button.removeAttribute('onclick');
            
            // Add event listener
            button.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                console.log('Notify button clicked', this);
                
                if (typeof window.NotifyWidget !== 'undefined' && window.NotifyWidget.open) {
                    window.NotifyWidget.open(this);
                } else {
                    console.error('NotifyWidget not found');
                    // Try to load it
                    setTimeout(() => {
                        if (typeof window.NotifyWidget !== 'undefined' && window.NotifyWidget.open) {
                            window.NotifyWidget.open(this);
                        }
                    }, 500);
                }
            });
        });
    }

    // Handle variant changes
    function handleVariantChange(variant) {
        if (!variant) return;
        
        const stockWidget = document.querySelector('.stock-status-widget');
        if (!stockWidget) return;
        
        const lang = getCurrentLanguage();
        const trans = translations[lang] || translations.en;
        const productName = stockWidget.getAttribute('data-product-name') || 
                          document.querySelector('h1')?.textContent || 
                          'Product';
        
        // Determine stock level
        let stockLevel, dotColor, stockText, message;
        
        if (!variant.available) {
            stockLevel = 'out';
            dotColor = '#EF4444';
            stockText = trans.out_of_stock;
        } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 30) {
            stockLevel = 'low';
            dotColor = '#F59E0B';
            stockText = trans.low_stock;
            message = trans.few_items_left;
        } else {
            stockLevel = 'in';
            dotColor = '#22C55E';
            stockText = trans.in_stock;
            message = trans.ships_today;
        }
        
        // Build HTML
        let html = `
            <div style="display: flex; align-items: center; gap: 5px; margin-top: 0; margin-bottom: 5px; font-size: 25px; font-family: 'Futura Condensed PT', -apple-system, BlinkMacSystemFont, sans-serif;">
                <span class="stock-dot" style="width: 8px; height: 8px; background-color: ${dotColor}; border-radius: 50%; display: inline-block;"></span>
                <span class="stock-text" style="font-weight: 700; color: #333;">${stockText}</span>
                <span style="color: #999; margin: 0 2px;">|</span>
        `;
        
        if (stockLevel === 'out') {
            html += `
                <button type="button" 
                        class="notify-me-link"
                        style="color: #253A66; text-decoration: underline; cursor: pointer; background: none; border: none; font-size: 22px; font-family: inherit; padding: 0;"
                        data-product-id="${variant.product_id || ''}" 
                        data-product-name="${productName}"
                        data-product-variant="${variant.title || ''}"
                        data-variant-id="${variant.id}">
                    ${trans.notify_me}
                </button>
            `;
        } else {
            const messageColor = stockLevel === 'low' ? '#F59E0B' : '#666';
            const fontWeight = stockLevel === 'low' ? 'font-weight: 500;' : '';
            html += `<span class="stock-message" style="color: ${messageColor}; ${fontWeight}">${message}</span>`;
        }
        
        html += '</div>';
        
        // Update widget
        stockWidget.innerHTML = html;
        stockWidget.setAttribute('data-stock-level', stockLevel);
        stockWidget.setAttribute('data-variant-id', variant.id);
        
        // Re-initialize buttons and fix translations
        setTimeout(() => {
            initNotifyButtons();
            fixTranslationMissing();
        }, 100);
    }

    // Initialize everything when DOM is ready
    function initialize() {
        console.log('Stock status updater initializing...');
        
        // Fix translations immediately
        fixTranslationMissing();
        
        // Initialize notify buttons
        initNotifyButtons();
        
        // Set up mutation observer to catch any dynamic content
        const observer = new MutationObserver((mutations) => {
            let shouldFix = false;
            mutations.forEach(mutation => {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) {
                            shouldFix = true;
                        }
                    });
                }
            });
            
            if (shouldFix) {
                setTimeout(() => {
                    fixTranslationMissing();
                    initNotifyButtons();
                }, 10);
            }
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            characterData: true
        });
        
        // Listen for variant changes
        document.addEventListener('variant:change', function(event) {
            console.log('Variant change detected', event.detail);
            if (event.detail && event.detail.variant) {
                handleVariantChange(event.detail.variant);
            }
        });
        
        // Also listen for form changes as backup
        const form = document.querySelector('form[action*="/cart/add"]');
        if (form) {
            form.addEventListener('change', function(e) {
                if (e.target.name === 'id' || e.target.type === 'radio') {
                    setTimeout(() => {
                        fixTranslationMissing();
                        initNotifyButtons();
                    }, 500);
                }
            });
        }
        
        // Fix translations periodically for the first few seconds
        let fixCount = 0;
        const fixInterval = setInterval(() => {
            fixTranslationMissing();
            fixCount++;
            if (fixCount > 10) {
                clearInterval(fixInterval);
            }
        }, 500);
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }
    
    // Also run on window load as backup
    window.addEventListener('load', function() {
        setTimeout(() => {
            fixTranslationMissing();
            initNotifyButtons();
        }, 1000);
    });
})();

// Make sure NotifyWidget is available globally
window.NotifyWidget = window.NotifyWidget || {
    open: function(button) {
        console.error('NotifyWidget not properly loaded. Please check notify-popup.js');
    },
    close: function() {
        console.error('NotifyWidget not properly loaded. Please check notify-popup.js');
    }
};